import VectorImageLayer from 'ol/layer/VectorImage';

class VectorLayerWMS extends VectorImageLayer {
  setStyle(style) {
    if (typeof style !== 'function') {
      super.setStyle(style);
      return;
    }

    super.setStyle((feature, resolution) => {
      const {
        params
      } = this.getSource();
      return style(feature, resolution, params);
    });
  }

}

export default VectorLayerWMS;